// CANONICAL COPY (GH #7115). src/constants/obligations/obl-ai-external-reporting.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-ai-external-reporting',
  title: 'Operate external reporting and AI incident communication channels',
  description:
    'Confirm that channels and procedures are established for external reporting on AI systems, including communication of serious incidents, malfunctions and material changes to authorities, affected persons and other interested parties within the timelines required by law or contract (ISO/IEC 42001 Annex A.8.3–A.8.5). Records of communications shall be retained. Review the AI external-reporting procedure, contact-authority register and the log of external AI communications in the period.',
  category: 'incidents',
  scfIds: ['SCF-AIG-010'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'AI external-reporting procedure is published' },
    { type: 'document-within-sla', description: 'Procedure review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
